import React, { useState, useContext } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Collapse,
  Modal,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import TableLoading from "components/Misc/TableLoading";
import ErrorMessage from "components/Misc/ErrorMessage";
import { EditOutlined } from "@material-ui/icons";
import { GET_GUARDS } from "lib/guards";
import { GetGuardsQueryResult, Gaurd } from "generated/graphql";
import { BuildingContext } from "Context/BuildingProvider";

interface GuardsTableState {
  limit: number;
  page: number;
  url: string;
  open: boolean;
}

const DEFAULT_STATE: GuardsTableState = {
  limit: 10,
  page: 0,
  url: "",
  open: false,
};

export default function GuardsTable() {
  const history = useHistory();
  const [state, setState] = useState(DEFAULT_STATE);
  const { currentBuilding } = useContext(BuildingContext);
  const { loading, error, data }: GetGuardsQueryResult = useQuery(GET_GUARDS, {
    variables: {
      limit: state.limit,
      offset: state.page,
      buildingId: currentBuilding?.Id,
    },
  });

  let modal;

  const handleEditClick = (id: string) => {};

  const handleSeePhotoClick = (url?: string | null) => {
    if (!!url) {
      setState({ ...state, url, open: true });
    }
  };

  const handleLimitChange = (event: any) => {
    setState({ ...state, limit: event.target.value });
  };

  const handlePageChange = (event: any, newPage: any) => {
    setState({ ...state, page: newPage });
  };

  const handleModalClose = () => {
    setState({ ...state, url: "", open: false });
  };

  if (loading) {
    return <TableLoading />;
  } else if (error) {
    return <ErrorMessage message={error.message}></ErrorMessage>;
  } else if (!!data?.Gaurd) {
    return (
      <React.Fragment>
        <Paper className="container">
          <PerfectScrollbar>
            <Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Password</TableCell>
                    <TableCell>Profile Picture</TableCell>
                    <TableCell>Created At</TableCell>
                    <TableCell>Updated At</TableCell>
                    <TableCell>Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.Gaurd.slice(0, state.limit).map((guard) => (
                    <TableRow hover key={guard.Id}>
                      <TableCell component="th" scope="row">
                        {guard.GaurdFirstName}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {guard.password}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            handleSeePhotoClick(guard?.Url);
                          }}
                        >
                          Show
                        </Button>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {guard.created_at}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {guard.updated_at}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            handleEditClick(guard.Id);
                          }}
                        >
                          <EditOutlined />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          <TablePagination
            component="div"
            count={
              data.Gaurd_aggregate.aggregate?.count
                ? data.Gaurd_aggregate.aggregate?.count
                : 0
            }
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleLimitChange}
            page={state.page}
            rowsPerPage={state.limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
        <Modal open={state.open} onClose={handleModalClose}>
          <img
            height="150px"
            width="150px"
            object-fit="cover"
            src={state.url}
          />
        </Modal>
      </React.Fragment>
    );
  } else {
    return <div>No Guards</div>;
  }
}
